const categorySortOrder = [
  'project_creation.category.general',
  'project_creation.category.system',
  'project_creation.category.configuration',
  'project_creation.category.system_software',
  'project_creation.category.baseboard',
  'project_creation.category.baseboard_power',
  'project_creation.category.max_pq',
  'project_creation.category.clock',
  'project_creation.category.pcb',
  'project_creation.category.pcie_interface',
  'project_creation.category.input_connector',
  'project_creation.category.memory',
  'project_creation.category.display_connector',
  'project_creation.category.cpu',
  'project_creation.category.cpu_root_port',
  'project_creation.category.power',
  'project_creation.category.power_supply',
  'project_creation.category.battery',
  'project_creation.category.thermal',
  'project_creation.category.thermal_interface_material_detail',
  'project_creation.category.system_configuration',
  'project_creation.category.mgx_bay_type',
  'project_creation.category.system_management_and_firmware',
  'project_creation.category.mechanical',
  'project_creation.category.voltage_regulator',
  'notebook_project_creation.general.voltage_regulator',
  'project_creation.category.schedule',
  'project_creation.category.nic',
  'project_creation.category.pcie_switch_retimer',
  'project_creation.category.product_storage',
  'project_creation.category.system_management',
  'project_creation.category.nvlink_bridge',
  'project_creation.category.system_power_supply',
  'project_creation.category.io_switch_board',
  'project_creation.category.mission_profile',
  'project_creation.category.other',
  'project_creation.category.memory_storage_device',
  'project_creation.category.high_current_device',
  'project_creation.category.lc_voltage_regulator_device',
  'project_creation.category.fsi_interface',
  'project_creation.category.peripheral_interface_spi',
  'project_creation.category.peripheral_interfaces_i_2_c',
  'project_creation.category.fsync_signal',
  'project_creation.category.pwm',
  'project_creation.category.uart',
  'project_creation.category.peripheral_interfaces_dap',
  'project_creation.category.peripheral_interfaces_can',
  'project_creation.category.peripheral_interfaces_eth',
  'project_creation.category.peripheral_interfaces_usb_2',
  'project_creation.category.peripheral_interfaces_usb_3',
  'project_creation.category.peripheral_interfaces_pcie',
  'project_creation.category.display_hdmi',
  'project_creation.category.camera_video_input',
  'project_creation.category.system_saftey_mcu',
  'project_creation.category.system_ethernet_switch',
  'project_creation.category.strapping',
  'project_creation.category.external_display',
  'project_creation.category.embedded_display',
  'project_creation.category.retimer',
  'project_creation.category.video_inputs',
  'project_creation.category.connectivity',
  'project_creation.category.storage',
  'project_creation.category.audio',
  'project_creation.category.sensors',
  'project_creation.category.human_input_devices',
  'project_creation.category.embedded_controller',
  'project_creation.category.trusted_platform_module',
  'project_creation.category.feature',
]

const elementSortOrder = [
  // testing elements
  'project_creation.general.feature',
  'notebook_project_creation.general.voltage_regulator',
  // Product PGMS Elements
  'product_creation.desktop.pgm.tgp_max',
  'product_creation.desktop.pgm.tgp_rated',
  'product_creation.notebook.pgm.tgp_max',
  'product_creation.notebook.pgm.tgp_rated',
  'product_creation.desktop.pgm.pcie_speed',
  'product_creation.desktop.pgm.pcie_width',
  'product_creation.desktop.pgm.voltage_regulator',
  // Project Elements
  'project_creation.general.name',
  'project_creation.general.project_type',
  'notebook_project_creation.general.name',
  'notebook_project_creation.general.project_odm_name',
  'project_creation.general.project_odm_name',
  'project_creation.general.ae_resource_level',
  'project_creation.general.ssid',
  'notebook_project_creation.general.ssid',
  'project_creation.general.svid',
  'notebook_project_creation.general.svid',
  'project_creation.general.os_version',
  'project_creation.general.gpu_driver_version',
  'desktop_project_creation.general.customer_class',
  'project_creation.general.health',
  'notebook_project_creation.general.form_factors',
  'desktop_project_creation.general.clock',
  'notebook_project_creation.general.clock',
  'notebook_project_creation.general.gam_approval_id',
  'desktop_project_creation.general.pcb_height',
  'desktop_project_creation.general.pcb_length',
  'desktop_project_creation.general.pcb_thickness',
  'notebook_project_creation.general.pcb_thickness',
  'desktop_project_creation.general.pcb_material',
  'notebook_project_creation.general.pcb_material',
  'desktop_project_creation.general.pcb_technology',
  'notebook_project_creation.general.pcb_technology',
  'desktop_project_creation.general.pcb_stackup',
  'notebook_project_creation.general.pcb_stackup',
  'desktop_project_creation.general.tgp_rated',
  'desktop_project_creation.general.tgp_max',
  'notebook_project_creation.general.tgp_rated',
  'notebook_project_creation.general.tdp_limit',
  'notebook_project_creation.general.tgp_max',
  'notebook_project_creation.general.tsp_design',
  'notebook_project_creation.general.power_monitor_ic',
  'desktop_project_creation.general.power_monitor_ic',
  'desktop_project_creation.general.memory',
  'notebook_project_creation.general.memory',
  'desktop_project_creation.general.voltage_regulator',
  'desktop_project_creation.general.thermal_design_source',
  'desktop_project_creation.general.thermal_cooler_type',
  'notebook_project_creation.general.thermal_cooler_type',
  'desktop_project_creation.general.thermal_fan_type',
  'desktop_project_creation.general.thermal_fan_connector',
  'desktop_project_creation.general.thermal_fan_count',
  'desktop_project_creation.general.thermal_fan_cooler_contact',
  'notebook_project_creation.general.thermal_capacity',
  'notebook_project_creation.general.thermal_cpu_capacity',
  'notebook_project_creation.general.thermal_gpu_capacity',
  'notebook_project_creation.general.thermal_cooler_topology',
  'notebook_project_creation.general.thermal_qboost_budget',
  'notebook_project_creation.general.thermal_acoustic_temperature_limit',
  'desktop_project_creation.general.mechanical_top_z_height',
  'desktop_project_creation.general.mechanical_bottom_z_height',
  'desktop_project_creation.general.total_card_dimension_x',
  'desktop_project_creation.general.total_card_dimension_y',
  'desktop_project_creation.general.total_card_dimension_z',
  'desktop_project_creation.general.display_connector',
  'desktop_project_creation.general.product_class_type',
  'desktop_project_creation.general.pcie_speed',
  'desktop_project_creation.general.pcie_width',
  'desktop_project_creation.general.input_connector',
  'desktop_project_creation.general.schedule',
  'notebook_project_creation.general.schedule',
  'project_creation.general.restricted',
  // Sort Layer
  'notebook_project_creation.general.battery_size',
  'notebook_project_creation.general.battery_tgp',
  'notebook_project_creation.general.battery_discharge_rate',
  'notebook_project_creation.general.battery_ac_adapter_wattage',
  'notebook_project_creation.general.battery_ac_adapter_voltage',
  'notebook_project_creation.general.battery_ac_adapter_size',
  'notebook_project_creation.general.chassis_length',
  'notebook_project_creation.general.chassis_width',
  'notebook_project_creation.general.chassis_height',
  'notebook_project_creation.general.system_memory',
  'notebook_project_creation.general.system_memory_module_type',
  'notebook_project_creation.general.system_memory_configuration',
  'notebook_project_creation.general.system_storage',
  'notebook_project_creation.general.system_panel',
  'notebook_project_creation.general.system_cpu',
  'notebook_project_creation.general.system_pcie_speed',
  'notebook_project_creation.general.system_pcie_width',
  'notebook_project_creation.general.system_chipset',
  'notebook_project_creation.general.system_cpu_tdp',
  'notebook_project_creation.general.system_cpu',
  'notebook_project_creation.general.system_panel',
  'notebook_project_creation.general.thunderbolt_interface',
  'notebook_project_creation.general.thunderbolt_support',
  'notebook_project_creation.general.display_connector',
  'notebook_project_creation.general.advanced_optimus',
  'notebook_project_creation.general.display_ms_hybrid_mode',
  'notebook_project_creation.general.display_discrete_mode_no_edp_mux',
  'notebook_project_creation.general.display_edp_mux_part_number',
  'notebook_project_creation.general.external_display_connector',
  'notebook_project_creation.general.external_display_edp_mux_part_number',
  'notebook_project_creation.general.external_advanced_optimus',
  'notebook_project_creation.general.backlight',
  'notebook_project_creation.general.tcon_vendor',
  'notebook_project_creation.general.tcon_edp_version',
  'notebook_project_creation.general.edp_supported_features',
  'notebook_project_creation.general.embedded_system_panel',
  'notebook_project_creation.general.max_pq',
  'notebook_project_creation.general.max_pq_certification_participation',
  'notebook_project_creation.general.max_pq_platform_power_aware_gpu_boost',
  'notebook_project_creation.general.max_pq_platform_power_aware_gpu_boost_dc',
  'notebook_project_creation.general.max_pq_configurable_tgp_mode',
  'notebook_project_creation.general.max_pq_configurable_tgp_value',
  'notebook_project_creation.general.tgp_offset',
  'notebook_project_creation.general.shipping_tgp',
  'notebook_project_creation.general.max_tgp',
  'notebook_project_creation.general.voltage_regulator',
  'notebook_project_creation.general.pd_controller',
  'notebook_project_creation.general.power_components',

  'notebook_project_creation.general.retimer_hdmi',
  'notebook_project_creation.general.retimer_usb',

  'notebook_project_creation.general.camera',

  'notebook_project_creation.general.connectivity_wifi',
  'notebook_project_creation.general.connectivity_bluetooth',
  'notebook_project_creation.general.storage_ssd',
  'notebook_project_creation.general.storage_nor_flash',
  'notebook_project_creation.general.removable_ssd_storage',
  'notebook_project_creation.general.codec_hifi',
  'notebook_project_creation.general.codec_voice',
  'notebook_project_creation.general.amplifier',
  'notebook_project_creation.general.dmic',
  'notebook_project_creation.general.audio_bluetooth',
  'notebook_project_creation.general.accelerometer',
  'notebook_project_creation.general.gyro',
  'notebook_project_creation.general.magnetometer',
  'notebook_project_creation.general.ambient_light_sensor',
  'notebook_project_creation.general.thermal_sensor',
  'notebook_project_creation.general.touch_screen',
  'notebook_project_creation.general.trackpad',
  'notebook_project_creation.general.embedded_controller',
  'notebook_project_creation.general.trusted_platform_module',

  'tesla_project_creation.general.target_application',
  'hgx_project_creation.general.target_application',
  'hgx_project_creation.general.system_software',
  'quadro_project_creation.general.target_application',
  'enterprise_project_creation.general.system_model_name',
  'tesla_project_creation.general.system_form_factor',
  'hgx_project_creation.general.system_form_factor',
  'quadro_project_creation.general.system_form_factor',
  'enterprise_project_creation.general.system_rack_unit',
  'enterprise_project_creation.general.system_jbog',
  'hgx_project_creation.general.reference_design',
  'hgx_project_creation.general.mgx_compliant',
  'hgx_project_creation.general.node_count_chassis',
  'hgx_project_creation.general.tpm',
  'hgx_project_creation.general.rtc',
  'hgx_project_creation.general.management_board_details',
  'hgx_project_creation.general.bmc_vendor_pn',
  'hgx_project_creation.general.bmc_fw_vendor',
  'hgx_project_creation.general.lan_on_motherboard',
  'hgx_project_creation.general.bios_vendor',
  'hgx_project_creation.general.chassis_dimensions',
  'hgx_project_creation.general.pcb_layers',
  'hgx_project_creation.general.nvme_hot_plug_support',
  'hgx_project_creation.general.cable_cartridges_and_nvlink_switch',
  'hgx_project_creation.general.compute_motherboard',
  'hgx_project_creation.general.compute_tray_configuration',
  'hgx_project_creation.general.rack_type',
  'hgx_project_creation.general.rack_height',
  'hgx_project_creation.general.mgx_bay_type',
  'hgx_project_creation.general.gpu_memory_size',
  'enterprise_project_creation.general.system_memory_size',
  'enterprise_project_creation.general.system_cpu_count',
  'enterprise_project_creation.general.system_gpu_count',
  'quadro_project_creation.general.system_pcie_speed',
  'tesla_project_creation.general.system_pcie_speed',
  'hgx_project_creation.general.system_pcie_speed',
  'enterprise_project_creation.general.system_pcie_max_depth',
  'tesla_project_creation.general.system_nvlink_topology',
  'hgx_project_creation.general.system_nvlink_topology',
  'enterprise_project_creation.general.system_nvlink_bridge',
  'quadro_project_creation.general.system_nvlink_speed',
  'tesla_project_creation.general.system_nvlink_speed',
  'hgx_project_creation.general.system_nvlink_speed',
  'quadro_project_creation.general.tgp_rated',
  'tesla_project_creation.general.tgp_rated',
  'hgx_project_creation.general.tgp_rated',
  'hgx_project_creation.general.tmp_rated',
  'hgx_project_creation.general.tcp_rated',
  'hgx_project_creation.general.cpu_2_tcp_rated',
  'hgx_project_creation.general.default_cpu',
  'hgx_project_creation.general.cpu_root_port',
  'enterprise_project_creation.general.system_cpu',
  'enterprise_project_creation.general.cpu_frequency',
  'enterprise_project_creation.general.cpu_core_count',
  'hgx_project_creation.general.gpu_tray_height',
  'project_creation.general.system_notes',
  'enterprise_project_creation.general.nic',
  'enterprise_project_creation.general.pcie_switch_retimer',
  'enterprise_project_creation.general.product_storage',
  'hgx_project_creation.general.hgx_product_storage',
  'hgx_project_creation.general.system_management_interface',
  'hgx_project_creation.general.psu',
  'enterprise_project_creation.general.system_power_supply_config',
  'hgx_project_creation.general.power_supply_config',
  'hgx_project_creation.general.redundancy_configuration',
  'hgx_project_creation.general.psu_vendor_pn',
  'hgx_project_creation.general.psu_input_voltage',
  'hgx_project_creation.general.psu_output_voltage',
  'hgx_project_creation.general.psu_wattage',
  'hgx_project_creation.general.system_total_power',
  
  'hgx_project_creation.general.nvlink_bridge_mechanism',
  'hgx_project_creation.general.nvlink_board_material',
  'hgx_project_creation.general.nvlink_board_manufacturer',
  'hgx_project_creation.general.io_switch_board',
  'enterprise_project_creation.general.thermal_cooler_type',
  'hgx_project_creation.general.thermal_flow_rate',
  'enterprise_project_creation.general.thermal_airflow_direction',
  'hgx_project_creation.general.hgx_thermal_airflow_direction',
  'enterprise_project_creation.general.thermal_airflow_cfm',
  'enterprise_project_creation.general.thermal_airflow_inlet_temperature',
  'enterprise_project_creation.general.thermal_cooler_vendor',
  'enterprise_project_creation.general.thermal_interface_material',
  'hgx_project_creation.general.baseboard_count',
  'hgx_project_creation.general.baseboard_input_voltage',
  'hgx_project_creation.general.baseboard_power_total',
  'hgx_project_creation.general.baseboard_power_components',
  'enterprise_project_creation.general.system_cpu_tdp',
  'hgx_project_creation.general.system_cpu_2_tdp',
  'enterprise_project_creation.general.system_cpu_pcie_link',
  // automotive
  'automotive_project_creation.general.contract_start',
  'automotive_project_creation.general.contract_end',
  'project_creation.general.reference_design',
  'automotive_project_creation.general.nvidia_soc_product',
  'project_creation.general.configuration_use_case',
  'automotive_project_creation.general.cpu_speed',
  'automotive_project_creation.general.gpu_speed',
  'automotive_project_creation.general.pva_speed',
  'automotive_project_creation.general.dla_speed',
  'automotive_project_creation.general.low_power_mode_suspend_trigger',
  'automotive_project_creation.general.low_power_mode_wake_trigger',
  'automotive_project_creation.general.pcb_width',
  'automotive_project_creation.general.pcb_length',
  'automotive_project_creation.general.pcb_height',
  'automotive_project_creation.general.pcb_thickness',
  'automotive_project_creation.general.pcb_material',
  'automotive_project_creation.general.pcb_technology',
  'automotive_project_creation.general.pcb_stackup',
  'automotive_project_creation.general.pcb_layer',
  'automotive_project_creation.general.pcb_class',
  'project_creation.general.pcb_comments',
  'automotive_project_creation.general.chassis_length',
  'automotive_project_creation.general.chassis_height',
  'automotive_project_creation.general.chassis_width',
  'automotive_project_creation.general.max_vin_batt',
  'automotive_project_creation.general.min_vin_batt',
  'automotive_project_creation.general.target_application',
  'automotive_project_creation.general.system_pcie_speed',
  'automotive_project_creation.general.system_cpu_tdp',
  'automotive_project_creation.general.system_cpu_count',
  'automotive_project_creation.general.system_gpu_count',
  'automotive_project_creation.general.gpu_frequency',
  'automotive_project_creation.general.gpu_count_per_baseboard',
  'automotive_project_creation.general.cpu_core_count',
  'automotive_project_creation.general.system_pcie_max_depth',
  'automotive_project_creation.general.pcie_switch_retimer',
  'automotive_project_creation.general.memory_storage_device',
  'automotive_project_creation.general.high_current_device',
  'automotive_project_creation.general.lc_voltage_regulator_device',
  'automotive_project_creation.general.fsi_interface',
  'automotive_project_creation.general.peripheral_interface_spi',
  'automotive_project_creation.general.peripheral_interfaces_i_2_c',
  'automotive_project_creation.general.fsync_signal',
  'automotive_project_creation.general.pwm',
  'automotive_project_creation.general.uart',
  'automotive_project_creation.general.peripheral_interfaces_dap',
  'automotive_project_creation.general.peripheral_interfaces_can',
  'automotive_project_creation.general.peripheral_interfaces_eth',
  'automotive_project_creation.general.peripheral_interfaces_usb_2',
  'automotive_project_creation.general.peripheral_interfaces_usb_3',
  'automotive_project_creation.general.peripheral_interfaces_pcie',
  'automotive_project_creation.general.camera_video_input',
  'automotive_project_creation.general.system_saftey_mcu',
  'automotive_project_creation.general.display_hdmi',
  'automotive_project_creation.general.system_ethernet_switch',
  'automotive_project_creation.general.thermal_interface_material_detail',
  'automotive_project_creation.general.system_power_supply_config',
  'automotive_project_creation.general.baseboard_count',
  'automotive_project_creation.general.baseboard_input_voltage',
  'automotive_project_creation.general.module_voltage_min',
  'automotive_project_creation.general.module_voltage_max',
  'automotive_project_creation.general.thermal_cooler_type',
  'automotive_project_creation.general.thermal_airflow_inlet_temperature',
  'automotive_project_creation.general.thermal_airflow_inlet_max_temperature',
  'automotive_project_creation.general.thermal_interface_material',
  'automotive_project_creation.general.tim_2_bond_line_thickness',
  'automotive_project_creation.general.tim_3_bond_line_thickness',
  'automotive_project_creation.general.thermal_liquid_flow_direction',
  'automotive_project_creation.general.thermal_liquid_flow_rate',
  'automotive_project_creation.general.thermal_reference_type',
  'automotive_project_creation.general.thermal_heatpipe',
  'automotive_project_creation.general.thermal_stackup',
  'automotive_project_creation.general.thermal_average_pressure',
  'automotive_project_creation.general.gpu_target_temperature_thermal_simulation',
  'automotive_project_creation.general.thermal_solution',
  'automotive_project_creation.general.inlet_temperature',
  'automotive_project_creation.general.flow_rate',
  'automotive_project_creation.general.max_ambient_temperature',
  'automotive_project_creation.general.pressure_on_lid',
  'automotive_project_creation.general.max_ecu_ambient_temperature',
  'automotive_project_creation.general.min_ecu_ambient_temperature',
  'automotive_project_creation.general.soc_tdp',
  'automotive_project_creation.general.ecu_tdp',
  'automotive_project_creation.general.soc_subsystem_max',
  'automotive_project_creation.general.ecu_max_power',
  'automotive_project_creation.general.low_power_mode_support',
  'automotive_project_creation.general.thermal_solution_running_sc',
  'automotive_project_creation.general.thermal_solution_running_key_off',
  'automotive_project_creation.general.system_power_source',
  'automotive_project_creation.general.mission_profile',
  'automotive_project_creation.general.waterproof_rating',
  'automotive_project_creation.general.boot_time_kpi',
  'automotive_project_creation.general.ram_code',
  'automotive_project_creation.general.boot_select',
  'automotive_project_creation.general.boot_chain'
]

export const categoryOrder = Object.freeze(
  categorySortOrder.reduce((result, category, index) => ({
    ...result,
    [category]: index
  }), {})
)

export const elementOrder = Object.freeze(
  elementSortOrder.reduce((result, label, index) => ({
    ...result,
    [label]: index
  }), {})
)

export const MODULE_NAME = 'fulcrum/containers/Form/Project/' 
export const CLEAR = MODULE_NAME + 'CLEAR'
export const SET_IMPORT_DIALOG_ACTIVE = MODULE_NAME + 'SET_IMPORT_DIALOG_ACTIVE'
export const SET_IMPORT_DIALOG_CONFIRM = MODULE_NAME + 'SET_IMPORT_DIALOG_CONFIRM'
export const SET_IMPORT_DIALOG_DONE = MODULE_NAME + 'SET_IMPORT_DIALOG_DONE'
export const SET_IMPORT_DIALOG_ERROR = MODULE_NAME + 'SET_IMPORT_DIALOG_ERROR'
export const SET_PROJECT_LIST = MODULE_NAME + 'SET_PROJECT_LIST'
export const SET_PROJECT_SELECTED = MODULE_NAME + 'SET_PROJECT_SELECTED'

export const FETCH_PROJECT_SPEC = MODULE_NAME + 'FETCH_PROJECT_SPEC'
export const FETCH_PROJECT_SPEC_START = MODULE_NAME + 'FETCH_PROJECT_SPEC_START'
export const FETCH_PROJECT_SPEC_SUCCESS = MODULE_NAME + 'FETCH_PROJECT_SPEC_SUCCESS'
export const FETCH_PROJECT_SPEC_ERROR = MODULE_NAME + 'FETCH_PROJECT_SPEC_ERROR'

export const FETCH_PROJECT_LIST = MODULE_NAME + 'FETCH_PROJECT_LIST'
export const FETCH_PROJECT_LIST_START = MODULE_NAME + 'FETCH_PROJECT_LIST_START'
export const FETCH_PROJECT_LIST_SUCCESS = MODULE_NAME + 'FETCH_PROJECT_LIST_SUCCESS'
export const FETCH_PROJECT_LIST_ERROR = MODULE_NAME + 'FETCH_PROJECT_LIST_ERROR'

